import React, { useState, useEffect } from "react";
import { Container, Icon, Grid, Button, Search } from "semantic-ui-react";

import Users from "../User/Management/List/Users";
import CreateUser from "../User/Management/Create";
import { isAccountSuspended } from "components/features/Util/Util";

import cx from "classnames";
import styles from "./cleverstory.module.scss";
import Workspaces from "./Workspaces";
import CreateWorkspace from "./Workspaces/CreateWorkspace";
import Domains from "./Domains";
import CreateDomain from "./Domains/CreateDomain";

// sort filter dropdown options
const userSortOptions = [
  { key: 0, text: "Name", value: "first_name" },
  { key: 1, text: "Created Date", value: "created_date" },
  { key: 2, text: "Last Active Date", value: "last_activity_date" },
];

export default function Cleverstory({ account, isWorkspace,isDomain }) {
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [searchText, setSearchText] = useState("");

  const [sort, setSort] = useState("first_name");
  const [order, setOrder] = useState("ASC");

  const [sortOptions, setSortOptions] = useState(userSortOptions);

  const [query, setQuery] = useState(null);
  const [type, setType] = useState("all");
  const [createUserOpen, setCreateUserOpen] = useState(false);

  return (
    <Container className={cx(styles.container)}>
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column className={cx(styles.title)}>
            {account ? account.name : " "}
          </Grid.Column>
          <Grid.Column textAlign="right">
            <Button
              className={cx(styles.btnCreate)}
              onClick={() => setCreateUserOpen(!createUserOpen)}
              content={
                <>
                  {isWorkspace && "Create Workspace" }
                  {isDomain && "Create Domain"}
                  <span className={cx(styles.icon)}>
                    <Icon name="plus" />
                  </span>
                </>
              }
              disabled={isAccountSuspended(account)}
            />
          </Grid.Column>
        </Grid.Row>

        {/* <Grid.Row columns={2} className={cx(styles.tabs)}>
          <Grid.Column className={styles.filtersCol} width={10} />
          <Grid.Column width={6} textAlign="right">
            <form
              // onSubmit={onSearchSubmit}
              className={cx(styles.search)}
            >
              <Search
                id="search"
                input={{
                  icon: (
                    <Icon
                      circular
                      name="search"
                      //  onClick={onSearchClick}
                    />
                  ),
                  className: cx(styles.input),
                }}
                showNoResults={false}
                placeholder="Search by name or email"
              ></Search>
            </form>
          </Grid.Column>
        </Grid.Row> */}

        <Grid.Row columns={2} className={cx(styles.p0)}>
          {/* <Grid.Column width={9}>
            {!loading && query && (
              <span>
                {total} results for{" "}
                <span className={styles.results}> "{query}" </span>
              </span>
            )}
          </Grid.Column> */}
          <Grid.Column width={7} textAlign="right" className={cx(styles.sort)}>
            {/* <SortFilter
              sort={sort}
              order={order}
              options={sortOptions}
              onSortChange={onSetSort}
              onOrderChange={onSetOrder}
              className={cx(styles.dropdown)}
            /> */}
          </Grid.Column>
        </Grid.Row>
      </Grid>

      {isWorkspace && (
        <>
          <Workspaces
            type="all"
            query={query}
            sort={sort}
            order={order}
            account={account}
            setTotal={setTotal}
            setLoading={setLoading}
          />
          <CreateWorkspace
            account={account}
            open={createUserOpen}
            setOpen={setCreateUserOpen}
          />
        </>
      )}
      {isDomain && (
        <>
          <Domains
            type="all"
            query={query}
            sort={sort}
            order={order}
            account={account}
            setTotal={setTotal}
            setLoading={setLoading}
          />
          <CreateDomain
            account={account}
            open={createUserOpen}
            setOpen={setCreateUserOpen}
          />
        </>
      )}
    </Container>
  );
}
